export default {
  locations: {
    gameStateAPI: process.env.REACT_APP_GAME_STATE_API || "",
    socket: process.env.REACT_APP_WEB_SOCKET || "",
  },
};
